
import service from '../request/index'


//登录-> 获取角色 -> 根据角色获取用户信息
// 用户登录接口
export function userLogin (data) {
  return service({
    url: '/api/newLogin',
    method: 'post',
    data
  })
}

// 返回切换角色列表 目前只返回 114:客服角色 3845:项目管理员 32:教师  
export function getRoleList (data) {
  return service({
    url: '/api/open/center/getRoleList',
    method: 'get',
    params: data
  })
}

// 返回个人中心显示信息  (获取用户信息)
export function getCenterInfo (data) {
  return service({
    url: '/api/open/center/getCenterInfo',
    method: 'get',
    params: data
  })
}

// 清空登录信息
export function quit (data) {
  return service({
    url: '/api/newLogin/quit',
    method: 'get',
    params: data
  })
}

//

// 是否登录 true--登录 false--未登录
export function isLoginorNot () {
  return service({
    url: '/api/open/already/login',
    method: 'GET',
  })
}


// 资源库PC端授权绑定
export function weChatWebBind (data) {
  return service({
    url: '/api/open/center/weChatWebBind',
    method: 'GET',
    params:data
  })
}


// 资源库PC端授权解绑
export function weChatWebUnBind (data) {
  return service({
    url: '/api/open/center/weChatWebUnBind',
    method: 'GET',
    params:data
  })
}

// 获取工作室列表
export function getStudioList (data) {
  return service({
    url: '/api/open/center/getProjectPage',
    method: 'get',
    params: data
  })
}
// 获取学科学段教材信息下拉列表
export function getSubjectOption (data) {
  return service({
    url: '/api/open/getSubjectOption',
    method: 'get',
    params: data
  })
}
// 研修分类
export function getTrainType (data) {
  return service({
    url: '/es/resource/lib/train/type',
    method: 'get',
    params: data
  })
}
// 资源评星
export function updateStar (data) {
  return service({
    url: '/es/resource/star/update/data',
    method: 'get',
    params: data
  })
}
// 收藏/取消收藏
export function updateCollect (data) {
  return service({
    url: '/es/resource/collect/update/data',
    method: 'get',
    params: data
  })
}
// 评论列表
export function getCommentList (data) {
  return service({
    url: '/es/resource/comment_reply/comment/list',
    method: 'post',
    data
  })
}
// 添加评论
export function saveComment (data) {
  return service({
    url: '/es/resource/comment_reply/comment/save',
    method: 'post',
    data
  })
}
// 回复列表
export function getFirstReply (data) {
  return service({
    url: '/es/resource/comment_reply/reply/list',
    method: 'post',
    data
  })
}
// 添加回复
export function saveReply (data) {
  return service({
    url: '/es/resource/comment_reply/reply/save',
    method: 'post',
    data
  })
}
// 我的评论
export function getMyCommentList (data) {
  return service({
    url: '/es/resource/comment_reply/myself/list',
    method: 'post',
    data
  })
}
// 删除评论/回复
export function deleteComment (data) {
  return service({
    url: '/es/resource/comment_reply/delete',
    method: 'delete',
    data
  })
}
// 举报资源
export function confirmReport (data) {
  return service({
    url: '/es/resource/report/update/data',
    method: 'post',
    data
  })
}
// 下载资源
export function downloadResource (data) {
  return service({
    url: '/es/resource/download',
    method: 'get',
    params: data
  })
}
// 更新下载数据,更新下载记录和资源的下载次数
export function uploadDownloadData (data) {
  return service({
    url: '/es/resource/download/update/data',
    method: 'get',
    params: data
  })
}

//视频播放数统计
export function playRecord (data) {
  return service({
    url: '/es/resource/view/play/record',
    method: 'get',
    params: data
  })
}


// 支付订单--返回订单详情(没有订单会创建)
export function getPayInfoFromResourceId (data) {
  return service({
    url: '/es/resource/my/pay/info/resource',
    method: 'get',
    params: data
  })
}

// 支付订单--已有订单去支付
export function getPayInfoFromOrderId (data) {
  return service({
    url: '/es/resource/my/pay/info/order',
    method: 'get',
    params: data
  })
}

// 获取订单支付信息
export function getPayStatus (data) {
  return service({
    url: '/es/resource/my/order/success',
    method: 'get',
    params: data
  })
}

// 删除订单
export function deleteMyOrder (data) {
  return service({
    url: '/es/resource/my/delete',
    method: 'get',
    params: data
  })
}

// 取消订单
export function cancelOrder (data) {
  return service({
    url: '/es/resource/my/cancel',
    method: 'get',
    params: data
  })
}


// 余额购买资源
export function balancePay (data) {
  return service({
    url: '/es/resource/my/balance/pay',
    method: 'get',
    params: data
  })
}

// 密码验证
export function passwordCheck (data) {
  return service({
    url: '/es/resource/my/password/check',
    method: 'post',
    data,
  })
}


// 资源库首页数据
export function getHomeData (data) {
  return service({
    url: '/es/resource/lib/home/data',
    method: 'get',
  })
}

// 更新浏览数据,更新浏览记录和资源的浏览次数
export function viewUpdate (data) {
  return service({
    url: '/es/resource/view/update/data',
    method: 'get',
    params: data
  })
}


// 登录用户信息
export function autoLoginByCASId (data) {
  return service({
    url: '/api/newLogin/auto',
    method: 'get',
    params: data
  })
}

// 我的优惠券列表-购买此课程可使用的券
export function myCouponListUseable (data) {
  return service({
    url: '/es/resource/my/myCouponListUseable',
    method: 'get',
    params: data
  })
}

// 我的优惠券列表-购买此课程不可使用的券
export function myCouponListUnuseable (data) {
  return service({
    url: '/es/resource/my/myCouponListUnuseable',
    method: 'get',
    params: data
  })
}

// 优惠券购买资源，电脑端
export function myCouponPay (data) {
  return service({
    url: '/es/resource/my/coupon/payPC',
    method: 'post',
    data
  })
}

// 自动登录
export function autoZykLogin (data) {
  return service({
    url: '/api/open/autoZykLogin',
    method: 'get',
    params: data
  })
}